import React from "react";
import colors from "../../../../config/colors";

export const MenuOptions = {
  browser: {
    icon: (
      <svg
        x="0px"
        y="0px"
        width="25px"
        height="25px"
        viewBox="0 0 93.93 93.93"
        fill={colors.background}
      >
        <g>
          <g>
            <rect x="50.602" y="50.602" width="28.057" height="28.055" />
            <rect x="15.274" y="15.272" width="28.055" height="28.057" />
            <rect x="50.602" y="15.272" width="28.057" height="28.057" />
            <path
              d="M91.332,0H2.598C1.164,0,0,1.162,0,2.598v88.734c0,1.434,1.164,2.598,2.598,2.598h88.734c1.436,0,2.598-1.164,2.598-2.598
       V2.598C93.93,1.162,92.768,0,91.332,0z M85.93,85.93H8V7.998h77.93V85.93z"
            />
            <rect x="15.274" y="50.602" width="28.055" height="28.055" />
          </g>
        </g>
      </svg>
    ),
    text: "Trending Stocks",
    url: "/app/browser",
  },
  dashboard: {
    icon: (
      <svg
        version="1.1"
        x="0px"
        y="0px"
        width="25px"
        height="25px"
        viewBox="0 0 93.802 93.802"
        fill={colors.background}
      >
        <g>
          <g>
            <polygon points="46.746,93.802 54.7,77.1 39.102,77.123 		" />
            <path d="M2.167,0v73.199h89.468V0H2.167z M85.825,67.391H7.977V5.81h77.848V67.391z" />
            <path
              d="M27.607,34.385l-10.45,10.874v18.349c0,0.516,0.419,0.936,0.936,0.936h12.688c0.517,0,0.936-0.419,0.936-0.936V35.461
       l-2.926-1.076H27.607z"
            />
            <path
              d="M53.45,42.913H40.763c-0.518,0-0.937,0.419-0.937,0.936v19.758c0,0.517,0.419,0.937,0.937,0.937H53.45
       c0.517,0,0.936-0.419,0.936-0.937V43.848C54.386,43.332,53.967,42.913,53.45,42.913z"
            />
            <path
              d="M71.892,22.785l-2.305-1.926l-8.339,9.097v33.651c0,0.516,0.419,0.936,0.937,0.936h12.688
       c0.517,0,0.936-0.419,0.936-0.936V23.095c-0.052,0.03-0.099,0.067-0.152,0.094c-0.485,0.254-1.03,0.388-1.578,0.388
       C73.278,23.578,72.504,23.297,71.892,22.785z"
            />
            <path
              d="M14.057,43.857c0.491,0,0.982-0.193,1.35-0.575L27.35,30.854l20.897,7.689c0.714,0.261,1.512,0.068,2.027-0.492
       L69.517,17.06l4.502,3.764c0.221,0.184,0.528,0.216,0.782,0.084c0.253-0.133,0.403-0.404,0.377-0.691L74.202,9.305
       c-0.034-0.39-0.379-0.677-0.768-0.642L62.521,9.637c-0.285,0.025-0.527,0.221-0.613,0.494c-0.027,0.09-0.036,0.183-0.028,0.274
       c0.017,0.184,0.104,0.358,0.251,0.48l4.512,3.771l-18.279,19.94l-20.866-7.678c-0.699-0.255-1.481-0.075-1.997,0.459
       L12.708,40.688c-0.716,0.746-0.693,1.93,0.053,2.646C13.123,43.683,13.59,43.857,14.057,43.857z"
            />
          </g>
        </g>
      </svg>
    ),
    text: "Stock Dashboard",
    url: "/app/dashboard",
  },
  blog: {
    icon: (
      <svg
        height="25px"
        viewBox="1 0 511 511.99995"
        width="25px"
        fill={colors.background}
      >
        <path d="m450.675781 125.457031-63.636719-63.636719-118.496093 119.488282 63.648437 63.644531zm0 0" />
        <path d="m211.527344 282.316406c-5.152344 12.371094 7.269531 24.777344 19.632812 19.609375l76.175782-39.40625-56.4375-56.4375zm0 0" />
        <path d="m508.105469 68.027344c5.859375-5.859375 5.859375-15.355469 0-21.214844l-42.421875-42.417969c-5.859375-5.859375-15.355469-5.859375-21.214844 0l-36.214844 36.214844 63.632813 63.636719zm0 0" />
        <path d="m45.5 421h15v76c0 6.0625 3.648438 11.542969 9.257812 13.855469 5.527344 2.308593 12.015626 1.078125 16.347657-3.25l86.605469-86.605469h174.789062c24.8125 0 45-20.1875 45-45v-148.933594l-47.316406 47.316406c-4.128906 4.132813-8.949219 7.382813-14.355469 9.652344l-85.882813 44.53125c-7.808593 3.371094-13.667968 4.558594-19.644531 4.558594-4.464843 0-8.769531-.859375-12.929687-2.125h-106.871094c-8.292969 0-15-6.710938-15-15 0-8.292969 6.707031-15 15-15h75.957031c-2.960937-9.820312-1.691406-20.457031 2.390625-30.21875l46.289063-89.898438c1.316406-3.324218 4.570312-8.160156 8.6875-12.273437l47.609375-47.609375h-240.933594c-24.8125 0-45 20.1875-45 45v210c0 24.8125 20.1875 45 45 45zm0 0" />
      </svg>
    ),
    text: "Blog",
    url: "https://marketsentiment.substack.com",
  },
};
